import { render, staticRenderFns } from "./groupservicecard.vue?vue&type=template&id=440418f0&lang=true&"
import script from "./groupservicecard.vue?vue&type=script&lang=js&"
export * from "./groupservicecard.vue?vue&type=script&lang=js&"
import style0 from "./groupservicecard.vue?vue&type=style&index=0&id=440418f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports